<template>
  <div>
    <!--顶部搜索-->
    <div id="components-form-demo-advanced-search">
      <a-form class="ant-advanced-search-form" :form="form" @submit="handleSearch">
        <a-row :gutter="24">
          <a-col :span="9">
            <a-form-item label="文件名">
              <a-input
                  style="width: 250px;"
                  v-decorator="[`infoName`]"
                  placeholder="请输入文件名搜索"
              />
            </a-form-item>
          </a-col>
          <a-col :span="9">
            <a-form-item label="关键词">
              <a-input
                  style="width: 250px;"
                  v-decorator="[`keyWordsNames`]"
                  placeholder="请输入关键词搜索"
              />
            </a-form-item>
          </a-col>

          <a-col :span="6" :style="{ textAlign: 'right',lineHeight:'42px'}">
            <a-button type="primary" html-type="submit">
              搜索
            </a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="handleReset">
              重置
            </a-button>

          </a-col>
        </a-row>

      </a-form>
    </div>

    <div class="fix">
      <!--      左侧分类-->
      <div class="left_tree">
        <a-spin :spinning="treeSpin" style="height: 100%">
          <div>
            <vxe-button @click="add" style="margin:0 3px 10px 0">新增</vxe-button>
            <vxe-button @click="edit" style="margin:0 3px 10px 0">编辑</vxe-button>
            <vxe-button @click="del" style="margin:0 3px 10px 0">删除</vxe-button>
          </div>
          <a-tree
                  :show-icon="true"
                  :checkStrictly="true"
                  :defaultExpandAll="false"
                  :defaultExpandParent="true"
                  :expandedKeys.sync="defaultExpandedKeys"
                  :tree-data="deptList"
                  :selectedKeys="selectedKeys"
                  :replaceFields="{children:'children', title:'infoTypeName', key:'infoTypeId', value: 'infoTypeId'}"
                  @select="onSelect"
                  @check="onCheck"
          >
            <!--          :checkable="true"-->
            <a-icon type="team" slot="dealer" style="color:#2fcfeb"/>
            <a-icon type="cluster" slot="region" style="color:#52c41a"/>
          </a-tree>
        </a-spin>
      </div>

      <!--      右边内容-->
      <a-list
          :grid="{ gutter: 35,  xs: 2, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4}"
          :data-source="marketListData"
          style="width: 75%;float: left"
      >
        <a-list-item slot="renderItem" slot-scope="item,index">
          <div class="item_box new pr" @click="createNew" v-if="item.isFirst">
            <p class="new_icon">
              <a-icon class="add_icon" type="plus-circle" theme="filled"/>
            </p>
            <p class="new_tips tr">创建对外资料</p>
          </div>
          <div class="item_box pr" v-if="index">
            <div class="img_box pr" @click="showDetail(item.infoId)">

              <img v-if="item.infoClassify == 'image' && item.infoUrl"
                   :src="api.temp.FILE_PATH + item.infoUrl.split(',')[0]">
              <!--              文件视频封面图图-->
              <img v-else-if="(item.infoClassify == 'video' || item.infoClassify == 'file') && item.coverImg"
                   :src="api.temp.FILE_PATH + item.coverImg">
              <img v-else-if="item.infoClassify == 'file' && !item.coverImg" src="@/assets/img/file_img.png">
              <!--              视频默认图-->
              <img v-else src="@/assets/img/video.png">


              <div class="pop_btns pa">
                <div class="top_btns">
                  <span></span>
                  <p class="icons ">
                  <span class="icon">
                    <a-icon type="edit" @click.stop="showDetail(item.infoId)"/>
                  </span>
                    <a-popconfirm title="确定删除吗？" ok-text="确定"
                                  cancel-text="取消" @confirm="deleteItem(item.infoId)">
                      <span class="icon" @click.stop="e => e.preventDefault()"><a-icon type="delete"/></span>
                    </a-popconfirm>
                    <span class="icon" v-if="item.infoUrl">
                    <a-icon type="download" @click.stop="download(item.infoUrl,item.infoName)"/>
                  </span>

                  </p>
                </div>

                <div class="bottom_btns">
                  <!--                  <span>分类：{{ item.brochureClassifyName }}</span>-->
                  <span>创建人：{{ item.createUserName }}</span>
                </div>
              </div>
            </div>
            <div class="title_box">
              <p class="title el">{{ item.infoName }}</p>
              <div></div>

            </div>
          </div>
        </a-list-item>

        <!--        <template v-slot:toolbarConfig></template>-->
      </a-list>
    </div>
    <!--    分页-->
    <div v-if="totalPage>0" class="pagination" style="float: right">
      <a-pagination
          :current="currPage"
          :total="totalCount"
          :pageSize="limit"
          show-less-items
          @change="handleChangePage"
      />
    </div>

    <!--明细页表单简化通用写法-->
    <a-modal
        title="对外资料详情"
        centered
        :closable="true"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="1200"
        @cancel="closeEdit(false)"
    >
<!--      :infoTypeId="infoTypeId"-->
      <detailForm :rowId="editRowId"

                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit(false)"
                  @saved="closeEdit(true)">
      </detailForm>
    </a-modal>


    <a-modal
        title="对外资料分组"
        :closable="true"
        :footer="null"
        :maskClosable="false"
        :visible="editQuestion"
        @cancel="closeQuestion()"
        :width="600"
    >
      <fileTree :rowId="editQuestionId"
                :parentId="parentId"
                v-if="editQuestion"
                ref="editQuestion"
                @cancelled="closeQuestion()"
                @saved="closeQuestion(true)">
      </fileTree>
    </a-modal>

    <!--页面加载-->
    <loading></loading>
  </div>
</template>

<script>
import {fac, mapState} from "@/utils/common/XGridBase"
import api from '@/services/api'

import {dataApi} from "@/services/question/external";
import {XEUtils} from "@/utils/common/FormBase";
import detailForm from "./fileDetail";
import fileTree from "./detail/fileTreeDetail";
import loading from '@/components/common/loading'
//列表接口
// const url = api.answer.EXTERNAL;

//主键
const rowId = "infoId";




//可编辑表格约束
const pagerConfig = fac.makePagerConfig();


export default {
  // mixins: [GridMixin],
  authorize: {},
  components: {
    detailForm,
    fileTree,
    loading
    // setPassword,
  },

  computed: {
    ...mapState("account", {currUser: "user"}),
  },
  mounted() {
    this.getQuestionTree();
    this.marketList();
  },
  data() {
    return {
      api,
      // popConfig,
      editModalVisible:false,
      form: this.$form.createForm(this, {name: 'advanced_search'}),
      marketListData: [],//产品宣传册数据
      search: {
        // 'filter.eq.contentType': 1,
        'infoTypeId': ''
      },
      searchResult:{},
      totalCount: 0,//总条数
      currPage: '',//当前页
      totalPage: 0,//总页数
      page: 1,
      limit: 7,
      rowId,
      url:api.answer.EXTERNAL,
      pagerConfig,
      checkedKeys: [],
      allList: [],
      deptList: [],
      defaultExpandedKeys: [],
      selectedKeys: [],
      treeSpin: false,
      token: localStorage.getItem('token'),
      editQuestion: false,
      editQuestionId: 0,
      parentId: 0,
      infoTypeId: ''
    };
  },
  methods: {
    /**
     * 调用树结构
     */
    async getQuestionTree() {
      let deptList = await dataApi.getQuestionTree();
      this.allList = deptList.data;
      this.deptList = XEUtils.toArrayTree(deptList.data, {
        key: 'infoTypeId',
        parentKey: 'parentId',
        children: 'children'
      })
      // this.defaultExpandedKeys = deptList.data.map(val => {
      //   //默认只展开一级
      // })
    },
    /**
     * 调用列表数据接口
     * @param result 搜索参数
     * @return {Promise<void>}
     */
    async marketList(result) {

      this.bus.$emit('loading', true);
      let entity = await dataApi.getProductList(result ? result : this.search, this.page);
      if (entity.code === 200) {
        entity.data.list.unshift({
          isFirst: true
        })
        this.totalCount = entity.data.totalCount //总条数
        this.currPage = entity.data.currPage ///当前页
        this.totalPage = entity.data.totalPage ///当前页
        this.marketListData = entity.data.list;
      }
      this.bus.$emit('loading', false);
    },
    /**
     *删除
     */
    deleteItem(id) {
      let $_that = this;
      dataApi.deleteFileItem(id).then(entity => {
        if (entity.code === 200) {
          $_that.marketList();
          // this.reload();
        }
      });
    },

    /**
     *  产品宣传册详情
     * @param id 详情id
     */
    showDetail(id) {
      this.editRowId = id;
      this.editModalVisible = true;
    },

    /**
     *   新建宣传册
     */
    createNew() {
      this.editRowId = 0;
      this.editModalVisible = true;
    },

    /**
     *  关闭详情弹窗
     */
    closeEdit(status) {
      this.editModalVisible = false;
      //详情新增编辑后 刷新页面
      if (status) {
        this.marketList();
      }
    },
    //  搜索
    async handleSearch(e) {
      e.preventDefault();
      // 清空选中树结构分类
      this.selectedKeys = []
      this.search.infoTypeId = ''
      // let searchResult;
      this.form.validateFields((error, values) => {
        console.log('error', error);
        console.log('Received values of form: ', values);
        this.searchResult = {
          'filter.like.infoName': values.infoName,
          'filter.like.keyWordsNames': values.keyWordsNames,
          'taskType': 1
        }
        this.marketList(this.searchResult)
      });
    },
    /**
     *  重置
     */
    handleReset() {
      // 清空选中树结构分类
      this.selectedKeys = []
      this.search.infoTypeId = ''
      this.searchResult['filter.like.keyWordsNames'] = ''
      this.searchResult['filter.like.infoName'] = ''
      this.form.resetFields();
      this.marketList();
    },


    /**
     * 选中树
     * @param selectedKeys
     */
    onSelect(selectedKeys) {
      var that = this;
      //清空上方搜索内容
      this.form.resetFields();
      // 清空搜索值
      this.searchResult['filter.like.keyWordsNames'] = ''
      this.searchResult['filter.like.infoName'] = ''
      this.selectedKeys = selectedKeys;
      this.infoTypeId = selectedKeys[0];
      this.search.infoTypeId = this. infoTypeId
      this.page = 1
      that.marketList()
    },
    /**
     * 选择复选框
     * @param checkedKeys
     */
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys.checked;
    },
    add() {
      if (this.selectedKeys.length) {
        this.parentId = this.selectedKeys[0]
      } else {
        this.parentId = null
      }
      this.editQuestionId = 0
      this.editQuestion = true
    },
    edit() {
      if (this.selectedKeys.length) {
        this.editQuestionId = this.selectedKeys[0]
        this.editQuestion = true
      } else {
        this.$message.error('请选择上级分组')
      }
    },
    del() {
      const vm = this
      if (this.selectedKeys.length) {
        this.$confirm({
          title: '确定要删除分组吗',
          content: '',
          onOk() {
            vm.doDel()
          },
          onCancel() {
            console.log('Cancel');
          }
        });
      } else {
        this.$message.error('请选择问题分组')
      }
    },
    doDel() {
      dataApi.delQuestionTree(this.selectedKeys[0]).then(res => {
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.getQuestionTree()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    closeQuestion(flag) {
      this.editQuestion = false
      if (flag) {
        this.getQuestionTree()
      }
    },
    download(src, fileName) {
      //文件下载记录
      let x = new XMLHttpRequest();
      x.open("GET", api.temp.FILE_PATH + src, true);
      x.responseType = 'blob';
      x.onload = function (e) {
        console.log(e);
        let url = window.URL.createObjectURL(x.response)
        let a = document.createElement('a');
        a.href = url
        a.download = fileName
        a.click()
      }
      x.send();
    },
    /**
     *  分页
     */
    handleChangePage(page) {
      this.page = page;
      // 如果上方筛选有值
      if (this.searchResult['filter.like.infoName'] || this.searchResult['filter.like.keyWordsNames']) {
        this.marketList(this.searchResult);
      } else if (this.search.carTypeId) { //如果选择了左侧树结构
        this.marketList(this.search)
      } else {
        this.marketList()
      }

    },
  },
};
</script>

<style scoped lang="less">
@import "../../../../assets/css/marketList.less";

//分页
.ant-pagination {
  padding-bottom: 20px;
}


.left_tree {
  width: 20%;
  padding: 20px;
  float: left;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  overflow-y: auto;
  margin-right: 20px;
}

.right_table {
  width: 80%;
  float: right;
  height: 100%;
}

//顶部搜索样式
.ant-advanced-search-form {
  padding: 24px 24px 12px;
  background: #fbfbfb;
  border: 1px solid #e1e1e1;
  border-radius: 6px;
  margin-bottom: 12px;
}

.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

///deep/ .ant-spin-container {
//  height: 100%;
//  display: flex;
//  flex-direction: column;
//}
///deep/ .ant-tree {
//  flex: 1;
//  overflow-y: scroll;
//}
</style>
